{
  "fields": {
    "switch": {
      "on": "Yes",
      "off": "No"
    },
    "search": {
      "placeholder": "Search..."
    }
  }
}
